import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b9d6bfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "direct-messages-page grid" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title w-full" }, "トーク", -1))
const _hoisted_4 = { class: "grid grid-nogutter" }
const _hoisted_5 = { class: "col-4 search-messages p-input-icon-left ml-0 mr-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-lms_search" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "card-body grid m-0"
}
const _hoisted_8 = { class: "col-4 user-list" }
const _hoisted_9 = { class: "user-list-wrapper" }
const _hoisted_10 = ["id", "onClick"]
const _hoisted_11 = { id: "user-avatar flex-auto" }
const _hoisted_12 = { class: "user-message" }
const _hoisted_13 = { class: "message-header grid grid-nogutter" }
const _hoisted_14 = { class: "col-8" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = {
  key: 0,
  class: "last-message-sent flex justify-content-end flex-wrap align-content-center"
}
const _hoisted_17 = {
  key: 0,
  class: "pi pi-bell ml-2 text-red-400"
}
const _hoisted_18 = {
  key: 0,
  class: "message-body text-justify inline-block"
}
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "col-8 message-box" }
const _hoisted_21 = {
  key: 0,
  class: "input-search-wrap relative"
}
const _hoisted_22 = { class: "search-control-wrap flex gap-2" }
const _hoisted_23 = { class: "p-inputgroup flex-1" }
const _hoisted_24 = {
  key: 0,
  class: "total-results flex justify-content-center align-items-center"
}
const _hoisted_25 = { class: "font-bold" }
const _hoisted_26 = {
  key: 0,
  class: "search-result-wrap absolute z-5"
}
const _hoisted_27 = { class: "results" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "avatar-wrap" }
const _hoisted_30 = {
  key: 0,
  class: "p-avatar p-component p-avatar-circle p-avatar-lg m-2"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "info-wrap" }
const _hoisted_33 = { class: "user-name" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "time-wrap" }
const _hoisted_36 = { class: "message-chat-input" }
const _hoisted_37 = { class: "flex justify-content-between align-items-center flex-wrap my-2 relative" }
const _hoisted_38 = { class: "flex justify-content-start" }
const _hoisted_39 = { class: "flex justify-content-end" }
const _hoisted_40 = { class: "message-chat-action" }
const _hoisted_41 = { class: "upload-file" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["alt", "src"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  id: "direct-messages-close-btn-wrapper",
  class: "right-sidebar col-4"
}
const _hoisted_46 = { class: "close-sidebar" }
const _hoisted_47 = {
  key: 1,
  class: "show-sidebar"
}

import "../../../../node_modules/vue3-emoji-picker/dist/style.css";
import { createConsumer } from "@rails/actioncable";
import { AccountServices, DirectMessageServices } from "@/clinic/services";
import { get, set, useArrayFindIndex, templateRef } from "@vueuse/core";
import { ILineAccount, ICustomer, ApiBaseReq } from "@/clinic/typings";
import { onBeforeMount, ref, computed, inject, provide, toRefs, watch } from "vue";
import { useStore } from "vuex";
import { useDebounceFn, UseScrollReturn } from "@vueuse/core";
import { vScroll } from "@vueuse/components";
import ApiRouterConstants from "@/clinic/constants/api.router.constants";
import Avatar from "primevue/avatar";
import axios, { AxiosResponse } from "axios";
import EmojiPicker from "vue3-emoji-picker";
import FileUpload from "primevue/fileupload";
import MessageUtils from "@/clinic/utils/message-utils";
import moment from "moment";
import RightSideBar from "./components/RightSideBar.vue";
import NoData from "./components/NoData.vue";
import RouterConstants from "@/common/constants/app.constants";
import Textarea from "primevue/textarea";
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { useCookies } from "@vueuse/integrations/useCookies";
import Dialog from "primevue/dialog";
import { useRoute } from "vue-router";

import { notityErrorMsg, notifySuccessMsg } from "@/clinic/utils/notify-utils";
import { GROUP_NAMES_EMOJI, PLACEHOLDER_EMOJI } from "@/clinic/typings/constants/clinic";
import LineAccountStatus from "./components/LineAccountList/status.vue";
import SupportStatusToolbar from "./components/LineAccountList/support-status-toolbar.vue";
import MessageList from "./components/MessageList/index.vue";
import LineAccountName from "./components/LineAccountList/name.vue";
import LineAccountShowTimeAgo from "./components/LineAccountList/show-time-ago.vue";
import LiveMessageTemplate from "./components/LiveMessageTemplate";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const toast = useToast();
const route = useRoute();
const { get: getCookie } = useCookies();
const clinicId = ref(0);
const users = ref<ILineAccount[]>([]);
const search = ref("");
const emojiPickerWrapper = ref();
const dialogVisible = ref<boolean>(false);
const showSearchInput = ref<boolean>(false);
const searchKeyword = ref<string>("");
const searchResults = ref([]);
const showSearchResults = ref<boolean>(false);
const searchPage = ref(0);
const searchRows = ref(10);
const totalResults = ref();
let line_user_id = ref(0);
const currentSearchMessage = ref({});
const currentUser = ref<ILineAccount>({
  id: 0,
  line_user_id: "",
  clinic_id: 0,
  customer_id: 0,
  name: "",
  avatar_url: "",
  message: {
    id: 0,
    channel_id: "",
    line_user_id: "",
    content: "",
    message_type: "",
    sender_type: "",
    created_at: "",
  },
} as ILineAccount);
const textMessageContent = ref("");
const files = ref([]);
const selectImageButton = ref();
const resetImageButton = ref();
const chatBox = ref();
const consumer = createConsumer(RouterConstants.WEBSOCKET_URL);
const loading = ref(false);
const emojiOnShow = ref(false);
const visibleSideBar = ref<boolean>(false);
const hasMessage = ref<boolean>(true);
const existsAccount = ref<boolean>(false);
const boxMessage = templateRef<InstanceType<typeof MessageList>>("boxMessage", null);
const boxRightSidebar = templateRef<InstanceType<typeof RightSideBar>>("boxRightSidebar", null);

const addTemplate = () => {
  dialogVisible.value = true;
};

const onCloseTemplatePopup = () => {
  dialogVisible.value = false;
};

const onInsertTemplate = template => {
  dialogVisible.value = false;
  const content = template.content_string
    .replaceAll("{{CustomerName}}", get(currentUser).name)
    .replaceAll("{{ClinicName}}", store.getters["authClient/selectedClinic"].name);
  set(textMessageContent, content);
};

const senderAvatar = (currentUserImage: string, senderType: string) => {
  if (senderType == "from_customer") {
    return currentUserImage;
  } else {
    const clinic = store.getters["authClient/selectedClinic"];
    return clinic.logo_url;
  }
};

const onScroll = async (state: UseScrollReturn) => {
  const { arrivedState, directions } = state;
  const { bottom } = toRefs(arrivedState);
  const { bottom: toBottom } = toRefs(directions);
  if (get(toBottom) && get(bottom) && get(totalResults) != get(searchResults).length) {
    const nextPage = get(searchPage) + 1;
    const { data } = await DirectMessageServices.searchMessages(
      get(searchKeyword),
      get(clinicId).value,
      currentUser.value.line_user_id,
      nextPage,
      get(searchRows)
    );
    searchResults.value = [
      ...searchResults.value,
      ...data.value.live_chat_messages.map(message => {
        return Object.assign(message, {
          text_content: MessageUtils.highlightSearchResult(
            MessageUtils.convertEmojisToImage(message),
            get(searchKeyword)
          ),
        });
      }),
    ];
    set(searchPage, nextPage);
  }
};

const toggleSearchInput = () => {
  if (get(showSearchInput)) {
    clearSearchInput();
  }
  set(showSearchInput, !get(showSearchInput));
};

const jumpToMessage = async (messageId, index) => {
  await get(boxMessage)?.loadMessage(messageId);
  const currentTarget = document.getElementById(`message-${messageId}`);
  set(showSearchResults, false);
  set(currentSearchMessage, { messageId: messageId, index: index + 1 });
  currentTarget.scrollIntoView();
  currentTarget.getElementsByClassName("message-body")[0].classList.add("shaking-message");
  setTimeout(() => {
    currentTarget.getElementsByClassName("message-body")[0].classList.remove("shaking-message");
  }, 1500);
};

const searchUp = async () => {
  const searchMessage = get(currentSearchMessage);
  let nextMessage = get(searchResults)[searchMessage.index];
  if (nextMessage == undefined) {
    const nextPage = get(searchPage) + 1;
    const { data } = await DirectMessageServices.searchMessages(
      get(searchKeyword),
      get(clinicId).value,
      currentUser.value.line_user_id,
      nextPage,
      get(searchRows)
    );
    searchResults.value = [
      ...searchResults.value,
      ...data.value.live_chat_messages.map(message => {
        return Object.assign(message, {
          text_content: MessageUtils.highlightSearchResult(
            MessageUtils.convertEmojisToImage(message),
            get(searchKeyword)
          ),
        });
      }),
    ];
    set(searchPage, nextPage);
  }
  nextMessage = get(searchResults)[searchMessage.index];
  jumpToMessage(nextMessage.id, searchMessage.index);
};

const searchDown = () => {
  const searchMessage = get(currentSearchMessage);
  const prevMessage = get(searchResults)[searchMessage.index - 2];
  jumpToMessage(prevMessage.id, searchMessage.index - 2);
};

const clearSearchInput = () => {
  set(searchKeyword, "");
  set(searchResults, []);
  set(currentSearchMessage, {});
  set(totalResults, undefined);
};

const searchFocus = () => {
  set(showSearchResults, true);
};

const searchOutFocus = () => {
  setTimeout(() => {
    set(showSearchResults, false);
  }, 100);
};

const searchMessages = useDebounceFn(async () => {
  const keyword = get(searchKeyword);
  if (keyword) {
    const { data } = await DirectMessageServices.searchMessages(
      get(searchKeyword),
      get(clinicId).value,
      currentUser.value.line_user_id,
      get(searchPage),
      get(searchRows)
    );
    totalResults.value = data.value.meta?.total_count;
    searchResults.value = data.value.live_chat_messages.map(message => {
      return Object.assign(message, {
        text_content: MessageUtils.highlightSearchResult(
          MessageUtils.convertEmojisToImage(message),
          get(searchKeyword)
        ),
      });
    });
    if (totalResults.value == 0) {
      currentSearchMessage.value = {};
    }
  } else {
    clearSearchInput();
  }
}, 500);

const toggleSidebar = () => (visibleSideBar.value = !visibleSideBar.value);

const showEmoji = () => {
  emojiOnShow.value = !emojiOnShow.value;
};

const onSelectEmoji = (emoji: any) => {
  textMessageContent.value += emoji.i;
};

const usersFiltered = computed(() => {
  return users.value.filter((user: any) => {
    return (
      user.name.toLowerCase().includes(search.value.toLowerCase()) ||
      user.customer?.name.toLowerCase().includes(search.value.toLowerCase())
    );
  });
});

const selectImage = () => {
  selectImageButton.value.$el.click();
};

const selectUser = (user: ILineAccount) => {
  if (get(boxMessage)?.hasLoadedMessage()) return;

  currentUser.value = user;
  if (user.message && !user.message?.read) {
    updateMessageAsRead(user.message.id);
  }
  get(boxMessage)?.enableLoadMore();
  get(boxMessage)?.refreshMessages();
  onSetCustomerIdRightSidebar(user?.customer?.id || 0);
  onLoadCustomerRightSidebar();
  onSetHasLinkCustomer(false);
  clearSearchInput();
  set(showSearchInput, false);
};

const updateMessageAsRead = async messageId => {
  await DirectMessageServices.updateMessageAsRead(messageId, get(clinicId).value, () => {
    currentUser.value.message.read = true;
  });
};

const onSelectedFiles = (event: { files: any }) => {
  files.value = event.files;
};

const sendMessage = () => {
  clearSearchInput();
  set(showSearchInput, false);
  loading.value = true;

  var formData = new FormData();
  formData.append("line_user_id", currentUser.value.line_user_id);

  if (files.value.length > 0) {
    formData.append("message_type", "image");
    formData.append("image", files.value[0]);
  } else if (textMessageContent.value != "") {
    formData.append("message_type", "text");
    formData.append("message", textMessageContent.value);
  }

  const token = getCookie("access_token");

  axios
    .post(`${ApiRouterConstants.API_LIVE_CHAT_MESSAGES}?clinic_id=${get(clinicId).value}`, formData, {
      headers: {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + token,
      },
    })
    .then((response: any) => {
      textMessageContent.value = "";
      get(boxMessage)?.appendMessage(response.data);

      files.value = [];
      resetImageButton.value.$el.click();

      const currentUserIndex = users.value.findIndex(user => user.line_user_id == response.data.line_user_id);
      users.value[currentUserIndex].message = response.data;
      users.value = sortUsersWithLatestMessage(users.value);

      loading.value = false;
    });
};

const createMessageSubscriptions = async () => {
  const channelId = await store.dispatch("authClient/getChannelIdCookie");

  consumer.subscriptions.create(
    {
      channel: "ApplicationCable::LiveChatMessagesChannel",
      channel_id: channelId,
    },
    {
      received(data: any) {
        const currentUserIndex = users.value.findIndex(user => user.line_user_id == data.line_user_id);
        users.value[currentUserIndex].message = data;
        users.value[currentUserIndex].support_status = "not_compatible";
        users.value = sortUsersWithLatestMessage(users.value);

        if (currentUser.value.line_user_id == data.line_user_id) get(boxMessage)?.appendMessage(data);
      },
    }
  );
};

const createAccountSubscriptions = async () => {
  const channelId = await store.dispatch("authClient/getChannelIdCookie");

  consumer.subscriptions.create(
    {
      channel: "ApplicationCable::LineAccountsChannel",
      channel_id: channelId,
    },
    {
      received(data: any) {
        set(users, [...users.value, data]);
      },
    }
  );
};

const sortUsersWithLatestMessage = (users: ILineAccount[]) => {
  return users.sort((first: any, second: any) => {
    if (!first.message?.created_at) {
      return 1;
    }

    if (!second.message?.created_at) {
      return -1;
    }

    const firstUser = moment(first.message.created_at).unix();
    const secondUser = moment(second.message.created_at).unix();
    if (firstUser > secondUser) {
      return -1;
    } else if (firstUser < secondUser) {
      return 1;
    }
  });
};

const loadClinicId = async () => set(clinicId, await inject("clinicId"));

const clinicIdParams = async (): Promise<ApiBaseReq> => ({ clinic_id: get(await get(clinicId)) });

const onLinkedCustomerSuccess = ({
  customerId,
  accountId,
  customer,
}: {
  customerId: number;
  accountId: number;
  customer: ICustomer;
}) => {
  const accountIdx = get(useArrayFindIndex(users, ({ id }: ILineAccount) => id == accountId));
  const account = get(users)[accountIdx];
  if (!account) return;

  account.customer = { ...account?.customer, ...customer };
  set(users, accountIdx, account);
  onSetCustomerIdRightSidebar(account?.customer?.id || 0);
  onLoadCustomerRightSidebar();
  onSetHasLinkCustomer(false);
};

const onClickStatusToolbar = async (status: string, accountId: number) => {
  AccountServices.changeSupportStatus(
    accountId,
    status,
    get(await get(clinicId)),
    () => {
      const accountIdx = get(useArrayFindIndex(users, ({ id }: ILineAccount) => id == accountId));
      if (get(users)[accountIdx]) {
        const account = get(users)[accountIdx];
        account.support_status = status;
        set(users, accountIdx, account);
      }
      notifySuccessMsg(toast, "保存が完了しました");
    },
    (error: any) => notityErrorMsg(toast, error)
  );
};
/**
 * If message or image don't have value button send message will disable
 */
const isEnterMessage = computed(() => get(textMessageContent).length > 0 || get(files).length > 0);
const handleDocumentClick = (event: Event) => {
  if (emojiOnShow.value && emojiPickerWrapper.value && !emojiPickerWrapper.value.contains(event.target)) {
    emojiOnShow.value = false;
  }
};
const onSetCustomerIdRightSidebar = (id: number) => {
  get(boxRightSidebar)?.setCustomerId(id);
};

const onLoadCustomerRightSidebar = () => get(boxRightSidebar)?.loadCustomer();

const onSetHasLinkCustomer = (hasLinked: boolean) => get(boxRightSidebar)?.setHasLinkCustomer(hasLinked);

provide("onSetCustomerIdRightSidebar", onSetCustomerIdRightSidebar);

provide("onLoadCustomerRightSidebar", onLoadCustomerRightSidebar);

provide("onSetHasLinkCustomer", onSetHasLinkCustomer);

onBeforeMount(async () => {
  document.addEventListener("click", handleDocumentClick);
  await loadClinicId();

  const { customerId } = route.query;
  const { data: accounts } = (await AccountServices.getAccounts(await clinicIdParams())) as unknown as AxiosResponse<
    ILineAccount[]
  >;

  const serializerAccounts = get(accounts);
  if (serializerAccounts.length > 0) {
    set(existsAccount, true);
  }

  let lineAccountFiltered = null;
  if (customerId) {
    lineAccountFiltered = serializerAccounts.find(account => {
      return account?.customer_id == customerId;
    });
    line_user_id = lineAccountFiltered.line_user_id;
  }

  set(users, sortUsersWithLatestMessage(serializerAccounts));
  const [user] = serializerAccounts;
  currentUser.value = lineAccountFiltered || user;
  onSetCustomerIdRightSidebar(user?.customer?.id || 0);
  onSetHasLinkCustomer(false);
  if (currentUser.value != undefined) {
    get(boxMessage)?.setLineAccount(user as ILineAccount);
    get(boxMessage)?.refreshMessages();

    createMessageSubscriptions();
    createAccountSubscriptions();

    const messagesWithData = get(users).filter(item => item.message !== null);
    if (messagesWithData.length == 0) {
      set(hasMessage, false);
    }
  } else {
    set(hasMessage, false);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass(["card-wrapper", visibleSideBar.value || !existsAccount.value ? 'col-12' : 'col-8'])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              class: "input-search",
              placeholder: "ユーザー名",
              modelValue: search.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event))
            }, null, 8, ["modelValue"])
          ]),
          (currentUser.value && existsAccount.value)
            ? (_openBlock(), _createBlock(SupportStatusToolbar, {
                key: 0,
                accountId: currentUser.value?.id,
                onClick: onClickStatusToolbar,
                onToggleSearchInput: toggleSearchInput
              }, null, 8, ["accountId"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (existsAccount.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usersFiltered), (user) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["user-wrapper flex justify-content-between cursor-pointer", {
                'active-user': currentUser.value.id === user.id,
                'unread-message': user.message != _ctx.undefine && !user.message?.read,
              }]),
                    key: user.name,
                    id: user.line_user_id,
                    onClick: ($event: any) => (selectUser(user))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      (user.avatar_url)
                        ? (_openBlock(), _createBlock(_unref(Avatar), {
                            key: 0,
                            image: user.avatar_url,
                            class: "mr-2",
                            size: "xlarge",
                            shape: "circle"
                          }, null, 8, ["image"]))
                        : (_openBlock(), _createBlock(_unref(Avatar), {
                            key: 1,
                            icon: "pi pi-user",
                            class: "mr-2",
                            size: "xlarge",
                            shape: "circle"
                          }))
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(LineAccountName, {
                            customer_code: user?.customer?.code,
                            customer_name: user?.customer?.name,
                            account_name: user.name
                          }, null, 8, ["customer_code", "customer_name", "account_name"])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          (user.message)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                _createVNode(LineAccountShowTimeAgo, {
                                  date: user.message.created_at
                                }, null, 8, ["date"]),
                                (!user.message?.read)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["message-content flex justify-content-between", { 'flex-row-reverse': !user.message }])
                      }, [
                        (user.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("span", {
                                innerHTML: _unref(MessageUtils).parseContentToShortMessage(user.message.content, user.message.message_type)
                              }, null, 8, _hoisted_19)
                            ]))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createVNode(LineAccountStatus, {
                        customer_status: user?.customer?.status,
                        support_status: user.support_status
                      }, null, 8, ["customer_status", "support_status"])
                    ])
                  ], 10, _hoisted_10))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              (showSearchInput.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_InputText, {
                          modelValue: searchKeyword.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchKeyword).value = $event)),
                          placeholder: "メッセージを検索",
                          onInput: _unref(searchMessages),
                          onFocus: searchFocus,
                          onBlur: searchOutFocus
                        }, null, 8, ["modelValue", "onInput"]),
                        (totalResults.value != _ctx.undefine && searchKeyword.value != '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (currentSearchMessage.value.index)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("span", _hoisted_25, _toDisplayString(currentSearchMessage.value.index), 1),
                                    _createElementVNode("span", null, "/" + _toDisplayString(totalResults.value), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(totalResults.value), 1)
                                  ], 64))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Button, {
                          class: "search-up",
                          icon: "pi pi-angle-up",
                          onClick: searchUp,
                          disabled: currentSearchMessage.value.index ? currentSearchMessage.value.index == totalResults.value : true
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_Button, {
                          class: "search-down",
                          icon: "pi pi-angle-down",
                          onClick: searchDown,
                          disabled: (currentSearchMessage.value.index || 0) <= 1
                        }, null, 8, ["disabled"])
                      ]),
                      _createVNode(_component_Button, {
                        class: "p-button-danger",
                        icon: "pi pi-times",
                        severity: "danger",
                        text: "",
                        "aria-label": "cancel",
                        onClick: toggleSearchInput
                      })
                    ]),
                    (searchResults.value.length > 0 && showSearchResults.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (message, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "message-wrap flex justify-content-between align-items-center",
                                key: message.id,
                                onClick: ($event: any) => (jumpToMessage(message.id, index))
                              }, [
                                _createElementVNode("div", _hoisted_29, [
                                  (senderAvatar(currentUser.value.avatar_url, message?.sender_type))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _createElementVNode("img", {
                                          class: "user-avatar border-circle",
                                          src: senderAvatar(currentUser.value.avatar_url, message?.sender_type),
                                          alt: "user-avatar"
                                        }, null, 8, _hoisted_31)
                                      ]))
                                    : (_openBlock(), _createBlock(_unref(Avatar), {
                                        key: 1,
                                        icon: "pi pi-user",
                                        class: "m-2",
                                        size: "large",
                                        shape: "circle"
                                      }))
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    (message.line_user_id == currentUser.value.line_user_id)
                                      ? (_openBlock(), _createBlock(LineAccountName, {
                                          key: 0,
                                          customer_code: currentUser.value?.customer?.code,
                                          customer_name: currentUser.value?.customer?.name,
                                          account_name: currentUser.value.name
                                        }, null, 8, ["customer_code", "customer_name", "account_name"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_unref(store).getters["authClient/selectedClinic"]?.name), 1)
                                        ], 64))
                                  ]),
                                  _createElementVNode("div", {
                                    class: "text-content",
                                    innerHTML: message.text_content
                                  }, null, 8, _hoisted_34)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(LineAccountShowTimeAgo, {
                                    date: message.created_at
                                  }, null, 8, ["date"])
                                ])
                              ], 8, _hoisted_28))
                            }), 128))
                          ])
                        ])), [
                          [_unref(vScroll), onScroll]
                        ])
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "message-chat-box",
                ref_key: "chatBox",
                ref: chatBox
              }, [
                _createVNode(MessageList, {
                  ref_key: "boxMessage",
                  ref: boxMessage,
                  account: currentUser.value,
                  line_user_id: _unref(line_user_id)
                }, null, 8, ["account", "line_user_id"])
              ], 512),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", {
                      class: "icon-lms_attach icon",
                      onClick: selectImage
                    }),
                    _createElementVNode("div", {
                      class: "w-full flex justify-content-end",
                      ref_key: "emojiPickerWrapper",
                      ref: emojiPickerWrapper
                    }, [
                      _createVNode(_unref(EmojiPicker), {
                        onSelect: onSelectEmoji,
                        class: _normalizeClass(["absolute emoji-picker", { hidden: !emojiOnShow.value }]),
                        "group-names": _unref(GROUP_NAMES_EMOJI),
                        native: true,
                        "static-texts": _unref(PLACEHOLDER_EMOJI)
                      }, null, 8, ["class", "group-names", "static-texts"]),
                      _createElementVNode("span", {
                        class: "icon-lms_face icon",
                        onClick: showEmoji
                      })
                    ], 512),
                    _createElementVNode("span", {
                      class: "pi pi-comment btn-la-chat-plus cursor-pointer",
                      onClick: addTemplate
                    }),
                    _createVNode(_unref(Dialog), {
                      visible: dialogVisible.value,
                      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((dialogVisible).value = $event)),
                      modal: "",
                      header: "コンテンツを選択",
                      style: { width: '75vw' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(LiveMessageTemplate), {
                          onOnClose: onCloseTemplatePopup,
                          onOnInsert: onInsertTemplate
                        })
                      ]),
                      _: 1
                    }, 8, ["visible"])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_Button, {
                      class: "send-button",
                      label: "送信する",
                      onClick: sendMessage,
                      loading: loading.value,
                      disabled: !_unref(isEnterMessage)
                    }, null, 8, ["loading", "disabled"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createVNode(_unref(FileUpload), {
                      accept: "image/png, image/jpeg",
                      fileLimit: 1,
                      maxFileSize: 10000000,
                      onSelect: onSelectedFiles
                    }, {
                      header: _withCtx(({ chooseCallback, clearCallback }) => [
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (chooseCallback()),
                          ref_key: "selectImageButton",
                          ref: selectImageButton
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_Button, {
                          onClick: ($event: any) => (clearCallback()),
                          ref_key: "resetImageButton",
                          ref: resetImageButton
                        }, null, 8, ["onClick"])
                      ]),
                      content: _withCtx(({ files, removeFileCallback }) => [
                        (files.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(files, (file, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: file.name + file.type + file.size,
                                  class: "image-preview-wrapper card relative inline-block"
                                }, [
                                  _createElementVNode("img", {
                                    role: "presentation",
                                    alt: file.name,
                                    src: file.objectURL,
                                    class: "shadow-2"
                                  }, null, 8, _hoisted_43),
                                  _createVNode(_component_Button, {
                                    icon: "pi pi-times",
                                    onClick: ($event: any) => (removeFileCallback(index)),
                                    class: "p-button-danger p-button-rounded p-button-outlined absolute"
                                  }, null, 8, ["onClick"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, files.value.length > 0]
                    ])
                  ]),
                  _withDirectives(_createVNode(_unref(Textarea), {
                    class: "w-full",
                    placeholder: "メッセージを入力。メッセージを入力",
                    modelValue: textMessageContent.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((textMessageContent).value = $event))
                  }, null, 8, ["modelValue"]), [
                    [_vShow, files.value.length <= 0]
                  ])
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_44, [
            _createVNode(NoData)
          ]))
    ], 2),
    (!visibleSideBar.value)
      ? _withDirectives((_openBlock(), _createElementBlock("aside", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createVNode(_component_Button, {
              class: "p-sidebar-close",
              icon: "icon-lms_close",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSidebar()))
            })
          ]),
          _createVNode(RightSideBar, {
            ref_key: "boxRightSidebar",
            ref: boxRightSidebar,
            "account-id": currentUser.value?.id,
            "clinic-id": clinicId.value.value,
            "current-customer": currentUser.value?.customer,
            onLinkedCustomerSuccess: onLinkedCustomerSuccess
          }, null, 8, ["account-id", "clinic-id", "current-customer"])
        ], 512)), [
          [_vShow, existsAccount.value]
        ])
      : _createCommentVNode("", true),
    (visibleSideBar.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createVNode(_component_Button, {
            icon: "icon-lms_person",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleSidebar()))
          })
        ], 512)), [
          [_vShow, existsAccount.value]
        ])
      : _createCommentVNode("", true),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})